module.exports = __webpack_public_path__ + "static/img/zd11.cfafe527.svg";